import React from 'react';

const styles = {
  wrap: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginBottom: '18px',
  },
  chip: (active) => ({
    fontSize: '12px',
    padding: '8px 14px',
    borderRadius: '999px',
    border: active ? '1px solid var(--accent)' : '1px solid var(--border)',
    background: active ? 'rgba(22, 163, 74, 0.12)' : 'var(--surface2)',
    color: active ? 'var(--accent-dark)' : 'var(--text)',
    cursor: 'pointer',
    transition: 'transform 0.15s, box-shadow 0.15s, background 0.15s',
    fontFamily: 'var(--font-mono)',
    letterSpacing: '0.02em',
    boxShadow: active ? '0 12px 30px rgba(22, 163, 74, 0.10)' : 'none',
  }),
};

export default function OptionsChips({ conversion, selectedOptions = [], onChange }) {
  if (!conversion) return null;

  const activeSet = new Set(selectedOptions);

  function toggle(opt) {
    const isQuality = opt.includes('Quality');
    
    if (activeSet.has(opt)) {
      onChange(selectedOptions.filter((item) => item !== opt));
    } else {
      if (isQuality) {
        // Remove any existing Quality options before adding this one
        const withoutQuality = selectedOptions.filter((item) => !item.includes('Quality'));
        onChange([...withoutQuality, opt]);
      } else {
        onChange([...selectedOptions, opt]);
      }
    }
  }

  return (
    <div style={styles.wrap}>
      {conversion.options.map((opt) => (
        <button
          key={opt}
          type="button"
          style={styles.chip(activeSet.has(opt))}
          onClick={() => toggle(opt)}
        >
          {activeSet.has(opt) ? '✓ ' : ''}
          {opt}
        </button>
      ))}
    </div>
  );
}
